// TODO: once we have a lot of complicated code here,
// let's switch to urijs which is 7kb gzipped w/o plugins.

/**
 * @param {string} search the value got from window.location.search
 * @param {string} params additional params in form a=b&c=d
 */
export const appendToLocationSearch = (search: string, params: string) => {
    if (search.startsWith('?')) {
        if (search === '?') {
            return `${search}${params}`;
        }

        return `${search}&${params}`;
    }

    if (search === '') {
        return `?${params}`;
    }

    return `?${search}&${params}`;
};

/**
 * Encodes an object into an erl-encoded query string.
 * @param {object|null} obj
 */
export function toQueryString(obj: {[k in string]: string} | null) {
    const parts = [];
    for (const i in obj) {
        if (obj.hasOwnProperty(i)) {
            parts.push(
                `${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`
            );
        }
    }

    return parts.join('&');
}

/**
 * Constructs a nicely looking relative URL.
 * @param {string} [path]
 * @param {string} [search]
 */
export function toRelativeUrl(path: string, search: string): string {
    if (path && search) {
        return `${path}?${search}`;
    }
    else if (path) {
        return path;
    }
    else if (search) {
        return `?${search}`;
    }

    return '';
}

export const getQueryParameter = (url: string, name: string): string | void => {
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);

    if (!results || !results[2]) {
        return undefined;
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const removeQueryParameters = () => {
    history.pushState({}, '', window.location.pathname);
};
